import React from "react";

import { useIntl } from "react-intl";

import PageMeta from "Components/PageMeta";
import { BackLink } from "ds/Button";
import Loading from "ds/PageLoading";
import useDecodedParams from "Hooks/useDecodedParams";
import DomainForm from "src/organization/pages/project/settings/domains/components/DomainForm";

import * as S from "./DomainNew.styles";

import type { Project } from "@packages/client";

interface DomainNewProps {
  project?: Project;
}
const DomainNew = ({ project }: DomainNewProps) => {
  const intl = useIntl();
  const { organizationId, projectId } = useDecodedParams<{
    organizationId: string;
    projectId: string;
  }>();

  return (
    <div>
      <PageMeta title={`Domains | ${project?.title}`} />

      <section aria-labelledby="settings-heading">
        {!project ? (
          <Loading />
        ) : (
          <>
            <BackLink
              from="domains"
              to={`/${organizationId}/${projectId}/-/settings/domains`}
            />

            <S.SettingsTitle tag="h2">
              {intl.formatMessage({
                id: "settings.domains.button.add_production_domain"
              })}
            </S.SettingsTitle>

            <S.Info>
              {intl.formatMessage({
                id: "settings.domains.info.enter.domain"
              })}
            </S.Info>
            <DomainForm cancellable />
          </>
        )}
      </section>
    </div>
  );
};

export default DomainNew;
